"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const decorators_1 = require("../decorators/decorators");
const styled_1 = __importDefault(require("../../styles/styled"));
const Card = (_a) => {
    var { animated, shadow, style, className, children, 'data-testid': testId, decoratorPosition, decoratorColor, variant = 'info' } = _a, rest = __rest(_a, ["animated", "shadow", "style", "className", "children", 'data-testid', "decoratorPosition", "decoratorColor", "variant"]);
    const side = decoratorPosition === 'side';
    const top = decoratorPosition === 'top';
    const danger = variant === 'danger';
    const info = variant === 'info';
    const success = variant === 'success';
    let decorator;
    switch (true) {
        case side && success:
            decorator = (0, jsx_runtime_1.jsx)(decorators_1.SideSolid, { decoratorColor: "greenShamrock" });
            break;
        case top && success:
            decorator = (0, jsx_runtime_1.jsx)(decorators_1.TopSolid, { decoratorColor: "greenShamrock" });
            break;
        case side && danger:
            decorator = (0, jsx_runtime_1.jsx)(decorators_1.SideSolid, { decoratorColor: "red50" });
            break;
        case top && danger:
            decorator = (0, jsx_runtime_1.jsx)(decorators_1.TopSolid, { decoratorColor: "red50" });
            break;
        case top && info:
            decorator = (0, jsx_runtime_1.jsx)(decorators_1.TopGradient, { animated: animated, customAnimatedColor: decoratorColor });
            break;
        case side && info:
            decorator = (0, jsx_runtime_1.jsx)(decorators_1.SideGradient, { animated: animated });
            break;
        default:
            decorator = undefined;
            break;
    }
    return ((0, jsx_runtime_1.jsxs)(CardWrapper, Object.assign({ "data-testid": testId, className: className, style: style, shadow: shadow, decorator: !!decorator }, rest, { children: [decorator, children] })));
};
exports.Card = Card;
exports.Card.defaultProps = {
    shadow: 'small',
};
const CardWrapper = styled_1.default.div(({ theme, shadow, decorator }) => ({
    position: 'relative',
    borderRadius: 4,
    padding: decorator ? '40px 32px 48px 56px' : '40px',
    boxShadow: theme.shadow[shadow],
    background: theme.colors.white,
}));
//# sourceMappingURL=card.js.map